define('models/StockoutProductModel',['underscore','ObjectModel','LocalStorage'],function (_,ObjectModel,LocalStorage) {
    //
    // Model Stockout Product
    //
    var StockoutProductModelPrototype = {

        name:'StockoutProductModel',
        idAttribute:'id_store',
        route:'apiStockoutProductModel',
        defaults:{
          products:[],
        },
        initialize:function(){
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(this,arguments);
            //
        },
        isStockout:function(id_product){
            return this.get('products').indexOf(id_product)>=0;
        }
    };

    var StockoutProductModel = ObjectModel.extend(LocalStorage).extend(StockoutProductModelPrototype);

    return StockoutProductModel;
});
